import PropTypes from "prop-types";
import { graphql } from "react-apollo";

export default function MutationFactory({ mutation, config, propTypes }) {
  function Mutation(props) {
    return props.children({ mutate: props.mutate });
  }

  Mutation.displayName = "Mutation";

  Mutation.propTypes = {
    children: PropTypes.func,
    mutate: PropTypes.func,
    ...propTypes,
  };

  return graphql(mutation, config)(Mutation);
}



// WEBPACK FOOTER //
// ./src/model/gql/mutations/mutationFactory.js